import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { TRACKER_API_BASE } from '../../../BaseUrl/BaseUrl';
import {
  startFormLoading,
  stopFormLoading,
  hasError,
  getErrorMessage,
  getSuccessMessage,
  setResponse,
} from '../../slices/responseStatus';
import { setScanRateLimitList } from '../../slices/scanRateLimitSlice';

const SCAN_RATE_LIMIT_URL = `${TRACKER_API_BASE}/scanRateLimit`;

function trackerHeaders() {
  const Token = window.localStorage.getItem('auth-token');
  return {
    headers: {
      'Content-Type': 'application/json',
      ...(Token ? { 'x-auth-token': Token } : {}),
    },
  };
}

function errorMessageFromCatch(e) {
  const payload = e?.response?.data ?? e;
  return payload?.meta?.message || payload?.error?.message || payload?.message || e?.message || 'Something went wrong';
}

export function* getScanRateLimitSaga() {
  try {
    yield put(startFormLoading());
    yield put(hasError(false));
    const response = yield call(() => axios.get(SCAN_RATE_LIMIT_URL, trackerHeaders()));
    const raw = response?.data?.data?.RateLimit;
    yield put(setScanRateLimitList(Array.isArray(raw) ? raw : []));
    yield put(stopFormLoading());
  } catch (e) {
    yield put(stopFormLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(errorMessageFromCatch(e)));
    yield put(setScanRateLimitList([]));
  }
}

export function* postScanRateLimitSaga(action) {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const body = action.payload || {};
    const response = yield call(() => axios.post(SCAN_RATE_LIMIT_URL, body, trackerHeaders()));
    const status = response?.status;
    if (status === 200 || status === 201) {
      yield put(getSuccessMessage(response?.data?.meta?.message || 'Saved successfully'));
      yield put(setResponse(status));
    }
    yield call(getScanRateLimitSaga);
  } catch (e) {
    yield put(stopFormLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(errorMessageFromCatch(e)));
  }
}
